import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import Page from './components/Page';
import { SettingsProvider } from 'context/SettingsContext';
import ScrollToTop from 'utils/scrollTop';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import './utils/i18n';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';

const App = () => {
  return (
    <Page>
      <SettingsProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <BrowserRouter>
            <ScrollToTop />
            <Routes />
          </BrowserRouter>
        </LocalizationProvider>
      </SettingsProvider>
    </Page>
  );
};

export default App;
